import React from 'react'
import classNames from 'classnames'

export interface TextTableCellProps {
  className?: string
  children: React.ReactNode
}

export const TextTableCell: React.FC<TextTableCellProps> = ({
  className,
  children,
}) => {
  return (
    <div
      className={classNames(
        'table-cell pb-2.5 phone:first:w-44 min-tablet:first:w-56',
        'first:font-medium first:pr-10',
        'last:overflow-x-auto',
        className
      )}
    >
      {children}
    </div>
  )
}
